// config.js
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA6Af6Sl3STcOwREhnHzr8MpEuY2lfWmBE",
    authDomain: "sound-bite-277bd.firebaseapp.com",
    databaseURL: "https://sound-bite-277bd.firebaseio.com",
    projectId: "sound-bite-277bd",
    storageBucket: "sound-bite-277bd.appspot.com",
    messagingSenderId: "342040421762",
    appId: "1:342040421762:web:5edc962b00bdee29aa9b9b",
    measurementId: "G-7E69FQD44P"
};

const algoliaConfig = {
    ALGOLIA_ID: '4YXR8SJR33',
    ALGOLIA_ADMIN_KEY: '35870bb59e5875f4d6fa1079f01fd34d',
    ALGOLIA_SEARCH_KEY: '5637f4bf6ec89469e92720ee0d26d5c1',
    ALGOLIA_INDEX_NAME: 'transcription',
};

export { firebaseConfig, algoliaConfig }; 